import { useContext } from 'react';
import type { RouteObject } from 'react-router-dom';
import { useRoutes as useRoutesBase } from 'react-router-dom';

import type { IContext } from './Context';
import Context from './Context';

export { default as Provider } from './Provider';

export function useRoutesData(): IContext {
  return useContext(Context);
}

export function useRoutes(): ReturnType<typeof useRoutesBase> {
  const { routes, basename } = useContext(Context);
  return useRoutesBase(routes as RouteObject[], basename);
}
